<template>
    <div :class="{'media__modal' : isModel}">
        <div v-if="type == 'image'" class="media__image">
            <img v-if="item && item.imageURL" :src="item.imageURL" alt="media image">
            <span v-else ><i class="far fa-image"></i></span>
        </div>
        <div v-if="['webGl'].includes(type)" class="media__viewer">
            <WebGlViewer  v-if="item && item.fileURL" :item="items" :src="item.fileURL"/>
            <span v-else ><i class="far fa-image"></i></span>
        </div>
        <div v-else-if="['glb','gltf'].includes(type)" class="media__viewer">
            <model-viewer  v-if="item && item.fileURL" :src="item.fileURL"/>
            <span v-else ><i class="far fa-image"></i></span>
        </div>
        <div v-if="type == 'video'" class="media__video" >
            <video v-if="item && item.videoURL && !isModel" :poster="poster ? poster : null">
                <source :src="item.videoURL" type="video/mp4">
            </video>
            <video v-else controls autoplay>
                <source :src="item.videoURL" type="video/mp4">
            </video>
       
            <span v-if="!item && !item.videoURL"> ><i class="far fa-image"></i></span>
            <span v-if="!isModel" class="play__icon"><i class="fas fa-play"></i></span>
        </div>
        <div v-if="type == 'audio'" class="media__audio" :style="`--audio : ${color}`">
               <audio
                    v-if="item && item.audioURL"
                    ref="audio"
                    controls
                    :src="item.audioURL"
                    @play="play"
                    @pause="pause"
                >
                </audio>
                    <!-- @timeupdate="play($event)" -->
        </div>
    </div>
</template>

<script>
  import Viewer from '../../components/global/viewer.vue';
  import WebGlViewer from '../../components/global/WebGlViewer.vue';
export default {
    props : { 
        type : { type : String, default : null},
        isModel : { type : Boolean, default : false},
        item : { type : Object, default : null},
        items : { type : Object, default : null},
        poster : { type : String, default : null},
        activeMedia : { type : String, default : null},
        color : { type : String, default : '#EEBA2E'}
    },
    components : { 'model-viewer' : Viewer, WebGlViewer },
    data(){
        return {
            audio : null,
            // media : "https://firebasestorage.googleapis.com/v0/b/ibegoo-dev.appspot.com/o/assetMedia%2Fimages%2F-Mp7uWy0M4uMOtHk4Bt2.jpg?alt=media&token=7af5d231-bb45-4f56-a106-115a15c8f73c"
        }
    },
    mounted () {
        this.audio = this.$refs.audio;
        // console.log(this.item);
    },

    watch : {
        activeMedia (value) {
            if(this.item && this.item._id != value) {
                this.audio.pause();
                this.audio.currentTime = 0;
            }
        }
    },

    methods: {
        play(e) {
            this.$emit('play',this.item._id)
        },
        pause(e) {}
    }
}
</script>

<style lang="scss" scoped>
//  *{
//     --audio : #EEBA2E;
// }
    .media__image {
        width : 4rem;
        height : 4rem;
        box-shadow:  0 0 1px;
        position : relative;
        background: #fff;
        border-radius: 0.4rem;
        img {
            width : 100%;
            height : 100%;
            object-fit: contain;
        }
        span {
            display:flex;
            align-items: center;
            justify-content: center;
            font-size: 1.9rem;
            color : #a8a8a8;
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
        }
    }
    .media__video {
        // @extend .media__image;
            width : 7rem;
            height : 5rem;
            box-shadow:  0 0 1px;
            position : relative;
            display:flex;
            align-items:center;
            justify-content:center;
        video {
            width : 100%;
            height : 100%;
            object-fit: cover;
        }
    }
    .play__icon {
        position:absolute;
        font-size: .9rem !important;
        color : #C21251;
        display:flex;
        align-items:center;
        justify-content:center;
       
        &:after {
        content:"";
        position: absolute;
        width : 2rem;
        height : 2rem;
        border-radius: 50%;
        background-color : #FFFFFF;
        opacity: .3;
        z-index: 1;
        }
        i{
            z-index: 2;
        }
    

    }
    .media__audio {
        audio {
            width: 18rem;
            height: 3rem;
            
        }
        audio::-webkit-media-controls-panel {
            // background-color: #EEBA2E;
            background-color: var(--audio);
        }
 
    }
    .media__viewer {
        @extend .media__image;
        display: flex;
        align-items: center;
        justify-content: center;
        model-viewer {
            height:100%;
            width: 100%;
        }
    }
    .media__modal {
        position : absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display:flex;
        align-items: center;
        justify-content: center;
        .media__image, .media__video {
           width : 76rem;
           height : 43rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/global/Media.vue